<template>
  <div>
    <!-- 退出弹框 -->
    <modalDefault
      :showModal="showModal"
      @close="close()"
      @confirm="confirm()"
      modalText="等级详情"
      :showCancel="false"
      :showConfirm="false"
    >
      <template #dialogContent>
        <div class="vip-content">
          <div class="vip-rule-detail">
            <div class="vip-text">充值可提升VIP等级，等级越高奖励越多</div>
            <div
              class="vip-text"
              v-if="vipLeverData.vipLevel == 0"
              style="color: red"
            >
              暂未达到VIP1领取等级
            </div>
            <div class="vip-text" v-else>
              当前可领取VIP{{ vipLeverData.vipLevel }}奖励
            </div>
            <div class="vip-reward-rule-box">
              <div
                class="reward-rule-title"
                style="font-size: 24rpx; color: #fff"
              >
                <div class="col-2">VIP等级</div>
                <div class="col-2" style="margin-right: 0.53 * 4.2px">
                  升级需充值
                </div>
                <div class="col-2">分享百分比</div>
                <div class="col-2">消费百分比</div>
                <div class="col-2">奖励金额</div>
                <div class="col-2">领取红包</div>
              </div>
              <div
                :class="[item.id == vipLeverData.vipLevel ? 'sel' : '']"
                v-for="(item, index) in levelLists"
                :key="index"
                class="rule-item"
              >
                <div class="col-2">{{ item.name }}</div>
                <div class="col-2" style="margin-right: 0.53 * 4.2px">
                  {{ item.rechargeThreshold }}
                </div>
                <div class="col-2" style="margin-right: 0.53 * 4.2px">
                  {{ consumeList[item.id].share }}%
                </div>
                <div class="col-2">{{ consumeList[item.id].consumption }}%</div>
                <div class="col-2">
                  {{ item.addedBonus }}G币
                </div>
                <div
                  v-if="!hasVipLevel.includes(String(item.id))"
                  class="col-2"
                  @click="getUserVipLevelRechargeThreshold(item.id)"
                >
                  领取
                </div>
                <div v-if="hasVipLevel.includes(String(item.id))" class="col-2">已领取</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
  <script>
import modalDefault from "@/components/common/modalDefault.vue";
import {
  getviplist,
  userVipLevelRechargeThreshold,
  getVipProgress,
  userHasVipLevelRechargeThreshold,
} from "@/api/index";
export default {
  name: "modalLogout",
  components: {
    modalDefault,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(newValue, oldValue) {
      if (newValue) {
        this.getHasVipLevel();
        this.getVipProgressFn();
        this.getLevelList();
      }
    },
  },
  data() {
    return {
      levelLists: [],
      vipLeverData: {},
      // 消费对比

      consumeList: {
        1: {
          share: "2.20",
          consumption: "0.40",
        },
        2: {
          share: "2.40",
          consumption: "0.60",
        },
        3: {
          share: "2.60",
          consumption: "0.80",
        },
        4: {
          share: "2.80",
          consumption: "1.00",
        },
        5: {
          share: "3.00",
          consumption: "1.30",
        },
        6: {
          share: "3.50",
          consumption: "1.50",
        },
        7: {
          share: "3.80",
          consumption: "2.00",
        },
        8: {
          share: "4.00",
          consumption: "2.50",
        },
        9: {
          share: "4.30",
          consumption: "3.00",
        },
        10: {
          share: "4.50",
          consumption: "3.50",
        },
      },
      hasVipLevel: [],
    };
  },
  methods: {
    getUserVipLevelRechargeThreshold(id) {
      // if (this.vipLeverData.vipLevel > id) {
      //   this.$message({ duration: 1000,
      //     message: "已超过领取等级",
      //     type: "warning",
      //     customClass: "log_warning",
      //   });
      //   return;
      // }
      if (this.vipLeverData.vipLevel < id) {
        this.$message({ duration: 1000,
          message: "暂未达到领取等级",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      userVipLevelRechargeThreshold({ vipLevel: id }).then((res) => {
        this.$message({ duration: 1000,
          message: "领取成功",
          type: "success",
          customClass: "log_success",
        });
        this.getHasVipLevel();
        this.getVipProgressFn();
        this.getLevelList();
      });
    },
    getLevelList() {
      getviplist().then((res) => {
        this.levelLists = res.data.data;
      });
    },
    getHasVipLevel() {
      userHasVipLevelRechargeThreshold().then((res) => {
        this.hasVipLevel = res.data.data;
      });
    },
    getVipProgressFn() {
      getVipProgress().then((res) => {
        if (res.data.code == 200) {
          this.vipLeverData = res.data.data;
        }
      });
    },
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.common-small-dialog-content {
  width: 100% !important;
}
.vip-rule-detail {
  padding-top: 4 * 4.2px;
}

.vip-rule-detail .vip-text {
  width: 71.6 * 4.2px;
  height: 5.47 * 4.2px;
  background: url("../../assets/images/vip_dialog_top_bg.png") no-repeat 0 0;
  background-size: 71.6 * 4.2px 5.47 * 4.2px;
  margin: 0 auto;
  font-size: 3.33 * 4.2px;
  color: #a6bbff;
  text-align: center;
}

.vip-rule-detail .vip-reward-rule-box {
  // width: 73.33*4.2px;
  height: auto;
  margin: 0 auto;
  padding-top: 4.4 * 4.2px;
}

.vip-rule-detail .vip-reward-rule-box .reward-rule-title {
  // width: 73.33*4.2px;
  height: 7.6 * 4.2px;
  // background: url("../../assets/images/vip_dialog_table_header_bg.png") no-repeat 0 0;
  // background: url("../../assets/images/table_header_bg.png") no-repeat 0 0;
  background-size: 100% 7.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background: #1e195c;
}

.vip-rule-detail .vip-reward-rule-box .reward-rule-title > div {
  float: left;
  line-height: 7.6 * 4.2px;
}

.vip-rule-detail .vip-reward-rule-box .col-1 {
  width: 31.73 * 4.2px;
  height: 7.6 * 4.2px;
  margin-right: 0.53 * 4.2px;
  text-align: center;
}

.vip-rule-detail .vip-reward-rule-box .col-2 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 7.6 * 4.2px;
  text-align: center;
}

.vip-rule-detail .vip-reward-rule-box .rule-item {
  // width: 73.33*4.2px;
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.vip-rule-detail .vip-reward-rule-box .rule-item.sel:before {
  content: "";
  width: 100%;
  height: 6.13 * 4.2px;
  background: url("../../assets/images/vip_dialog_tb_item_sel.png") no-repeat 0
    0;
  background-size: 100% 6.13 * 4.2px;
  position: absolute;
  left: 0;
  top: -0.27 * 4.2px;
  z-index: 5;
}

.vip-rule-detail .vip-reward-rule-box .rule-item > div {
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #a6bbff;
  position: relative;
  z-index: 10;
}

.vip-rule-detail .vip-reward-rule-box .rule-item:after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: url("../../assets/images/line11.png") no-repeat 0 0;
  background-size: 100% 1px;
  position: absolute;
  left: 0.93 * 4.2px;
  bottom: 0;
  z-index: 2;
}

.bottom-btn-wrap {
  width: 100%;
  height: auto;
  padding-bottom: 8 * 4.2px;
  padding-top: 5.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.opt-btn {
  width: 38 * 4.2px;
  height: 8.13 * 4.2px;
  background: url("../../assets/images/s_commit_btn.png") no-repeat 0 0;
  background-size: 38 * 4.2px 8.13 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.opt-btn text {
  margin-top: 0.53 * 4.2px;
}

.opt-btn.red {
  background-image: url("../../assets/images/del_confirm_btn.png");
}

.opt-btn.btn-2 {
  width: 29.27 * 4.2px;
  height: 10.67 * 4.2px;
  background-size: 29.27 * 4.2px 10.67 * 4.2px;
  font-size: 4 * 4.2px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
}
.vip-content {
  position: relative;
  width: 100%;
  height: auto;
  min-height: 66.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: unset;
  background-image: unset;
  font-size: 12px;
}
</style>